
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $6f019d1f45ba2738$export$2e2bcd8739ae039(targetElements, defaultProps) {
    if (!targetElements.length) return;
    ScrollReveal({
        reset: false
    });
    targetElements.forEach(({ element: element, animation: animation })=>{
        ScrollReveal().reveal(element, Object.assign({}, defaultProps, animation));
    });
}


var $b5f6d4efc654cf78$exports = {};
'use strict';
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.7.2
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        this.updateInitialPosition();
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.reset();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.event = {
            clientX: this.left + this.width / 2,
            clientY: this.top + this.height / 2
        };
        if (this.element && this.element.style) this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(0deg) " + "rotateY(0deg) " + "scale3d(1, 1, 1)";
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.updateInitialPosition = function updateInitialPosition() {
        if (this.settings.startX === 0 && this.settings.startY === 0) return;
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be disabled. Can be X or Y
   * @param {boolean} settings.glare - What axis should be disabled. Can be X or Y
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


function $b8855ed206bb3c2e$export$2e2bcd8739ae039() {
    const elements = document.querySelectorAll(".js-tilt");
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(elements);
}


const $d859da13df4a30ff$export$9c21a3269931e1e6 = {
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    distance: "30px",
    duration: 1000,
    desktop: true,
    mobile: true
};
const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    {
        element: ".section-title",
        animation: {
            delay: 300,
            distance: "0px",
            origin: "bottom"
        }
    },
    {
        element: ".hero-title",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".hero-cta",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".hero-intro",
        animation: {
            delay: 750,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".pixel-stage",
        animation: {
            delay: 850,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".vibe-card",
        animation: {
            delay: 500,
            interval: 120,
            origin: "bottom"
        }
    },
    {
        element: ".section-note",
        animation: {
            delay: 650,
            origin: "bottom"
        }
    },
    {
        element: ".social-links",
        animation: {
            delay: 800,
            origin: "bottom"
        }
    },
    {
        element: ".contact-wrapper",
        animation: {
            delay: 800,
            origin: "bottom"
        }
    }
];


(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007), (0, $d859da13df4a30ff$export$9c21a3269931e1e6));
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();
const $35da740d59af89ba$var$bootLines = [
    "sudo systemctl start ambition.service",
    "grep -R \"signal\" /var/log/life",
    "nmap -sV curiosity.local",
    "git commit -m \"ship the cleaner version\"",
    "SELECT pattern FROM messy_inputs;",
    "console.log('stay sharp');",
    "printf(\"hello, world\\n\");",
    "echo \"Talk is cheap. Show me the logs.\"",
    "print('less noise, more signal')",
    "python -m this",
    "chmod +x ./next-move",
    "tail -f /var/log/opportunity.log",
    "while true; do learn; done",
    "docker compose up focus",
    "def build_systems(for_fun=True): pass"
];
const $35da740d59af89ba$var$streamBootLines = ()=>{
    const stream = document.getElementById("bootStream");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!stream || reduceMotion) return;
    const shuffled = [
        ...$35da740d59af89ba$var$bootLines
    ].sort(()=>Math.random() - 0.5).slice(0, 6);
    shuffled.forEach((line, index)=>{
        window.setTimeout(()=>{
            const item = document.createElement("li");
            const prompt = document.createElement("b");
            prompt.textContent = "$";
            item.append(prompt, ` ${line}`);
            stream.appendChild(item);
        }, index * 260);
    });
};
$35da740d59af89ba$var$streamBootLines();
const $35da740d59af89ba$var$featuredSpotifySong = {
    title: "Somnus - Instrumental Version",
    artist: "Yoko Shimomura",
    url: "https://open.spotify.com/track/7fxzqLLTXObxIoTfI3FA0l?si=ce67f14a2bfd4563",
    cover: "https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02c1a3d757e86b84a5b7a68481"
};
const $35da740d59af89ba$var$renderFeaturedSpotifySong = ()=>{
    const card = document.getElementById("spotifyCard");
    const coverNode = document.getElementById("spotifyCover");
    const trackNode = document.getElementById("spotifyTrack");
    const artistNode = document.getElementById("spotifyArtist");
    if (!card || !trackNode || !artistNode) return;
    trackNode.textContent = $35da740d59af89ba$var$featuredSpotifySong.title;
    artistNode.textContent = $35da740d59af89ba$var$featuredSpotifySong.artist;
    card.href = $35da740d59af89ba$var$featuredSpotifySong.url;
    if (coverNode) {
        coverNode.src = $35da740d59af89ba$var$featuredSpotifySong.cover;
        coverNode.alt = `${$35da740d59af89ba$var$featuredSpotifySong.title} cover`;
    }
};
$35da740d59af89ba$var$renderFeaturedSpotifySong();
const $35da740d59af89ba$var$gtaLaunchDate = new Date("2026-11-19T00:00:00-05:00");
const $35da740d59af89ba$var$renderGtaCountdown = ()=>{
    const node = document.getElementById("gtaCountdown");
    if (!node) return;
    const diff = $35da740d59af89ba$var$gtaLaunchDate.getTime() - Date.now();
    if (diff <= 0) {
        node.textContent = "It is finally Vice City time.";
        return;
    }
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor(diff % 86400000 / 3600000);
    const minutes = Math.floor(diff % 3600000 / 60000);
    node.textContent = `${days}d ${hours}h ${minutes}m`;
};
$35da740d59af89ba$var$renderGtaCountdown();
window.setInterval($35da740d59af89ba$var$renderGtaCountdown, 60000);
const $35da740d59af89ba$var$historySubjects = [
    "Roman Empire",
    "Byzantine Empire",
    "Silk Road",
    "Library of Alexandria",
    "Abbasid Caliphate",
    "Mongol Empire",
    "Bronze Age collapse",
    "Hanseatic League",
    "Achaemenid Empire",
    "Song dynasty",
    "Umayyad Caliphate",
    "Ottoman Empire",
    "Indus Valley Civilisation",
    "Battle of Agincourt",
    "Age of Discovery",
    "Republic of Venice",
    "House of Wisdom",
    "Pax Romana",
    "Compound interest",
    "Opportunity cost",
    "Market liquidity",
    "Network effect",
    "Behavioral economics",
    "Game theory",
    "Supply chain management",
    "Risk management",
    "Trade finance",
    "Venture capital",
    "Economies of scale",
    "Business cycle",
    "Porter's five forces analysis",
    "Blue ocean strategy"
];
const $35da740d59af89ba$var$fallbackHistory = {
    title: "Roman Empire",
    extract: "The Roman Empire still shapes the way people talk about power, cities, law, armies, trade, collapse, and legacy.",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Colosseum_in_Rome%2C_Italy_-_April_2007.jpg/640px-Colosseum_in_Rome%2C_Italy_-_April_2007.jpg",
    url: "https://en.wikipedia.org/wiki/Roman_Empire"
};
let $35da740d59af89ba$var$lastHistorySubject = "";
const $35da740d59af89ba$var$pickHistorySubject = ()=>{
    const options = $35da740d59af89ba$var$historySubjects.filter((subject)=>subject !== $35da740d59af89ba$var$lastHistorySubject);
    const subject = options[Math.floor(Math.random() * options.length)];
    $35da740d59af89ba$var$lastHistorySubject = subject;
    return subject;
};
const $35da740d59af89ba$var$renderHistorySubject = (entry)=>{
    const image = document.getElementById("historyImage");
    const title = document.getElementById("historyTitle");
    const extract = document.getElementById("historyExtract");
    const link = document.getElementById("historyLink");
    if (!image || !title || !extract || !link) return;
    title.textContent = entry.title;
    const starterText = entry.extract.length > 260 ? `${entry.extract.slice(0, 257).trim()}...` : entry.extract;
    extract.textContent = starterText;
    link.href = entry.url;
    image.src = entry.image;
    image.alt = `${entry.title} image from Wikipedia`;
};
const $35da740d59af89ba$var$loadHistorySubject = async ()=>{
    const button = document.getElementById("historyRefresh");
    const subject = $35da740d59af89ba$var$pickHistorySubject();
    if (button) {
        button.disabled = true;
        button.textContent = "Looking...";
    }
    try {
        const response = await fetch(`https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(subject)}`);
        if (!response.ok) throw new Error("Wikipedia request failed");
        const data = await response.json();
        $35da740d59af89ba$var$renderHistorySubject({
            title: data.title || subject,
            extract: data.extract || $35da740d59af89ba$var$fallbackHistory.extract,
            image: data.thumbnail?.source || data.originalimage?.source || $35da740d59af89ba$var$fallbackHistory.image,
            url: data.content_urls?.desktop?.page || `https://en.wikipedia.org/wiki/${encodeURIComponent(subject)}`
        });
    } catch (error) {
        $35da740d59af89ba$var$renderHistorySubject($35da740d59af89ba$var$fallbackHistory);
    } finally{
        if (button) {
            button.disabled = false;
            button.textContent = "Change subject";
        }
    }
};
document.getElementById("historyRefresh")?.addEventListener("click", $35da740d59af89ba$var$loadHistorySubject);
$35da740d59af89ba$var$loadHistorySubject();
const $35da740d59af89ba$var$decorChatReplies = [
    "Hello! This AI chatbot is meant for decoration purposes only. You don\u2019t want me to waste tokens for nothing, so feel free to ask me directly.",
    "I would answer with great artificial wisdom, but this button is mostly here for the atmosphere. Ask Yousef directly and save the tokens.",
    "Decorative AI reporting in. I look intelligent, but today I am just protecting the token budget. Send the real question to Yousef.",
    "I asked the server for a deep answer, but it said we are on a budget. Yousef will do a better job anyway."
];
const $35da740d59af89ba$var$decorChatUsageKey = "0xyousef.decorativeChatUsed";
let $35da740d59af89ba$var$yousefGptCountry = "";
const $35da740d59af89ba$var$detectDeviceType = ()=>{
    const ua = navigator.userAgent || "";
    const hasTouch = navigator.maxTouchPoints > 1;
    if (/ipad|tablet|kindle|playbook|silk/i.test(ua)) return "Tablet";
    if (/mobi|iphone|ipod|android.*mobile|windows phone/i.test(ua)) return "Phone";
    if (hasTouch && Math.min(window.innerWidth, window.innerHeight) >= 700) return "Tablet";
    return "Desktop";
};
const $35da740d59af89ba$var$loadYousefGptCountry = async ()=>{
    try {
        const response = await fetch("https://ipapi.co/json/", {
            cache: "no-store"
        });
        if (!response.ok) throw new Error("Country lookup failed");
        const data = await response.json();
        const countryName = data.country_name || "";
        const countryCode = data.country_code ? ` (${data.country_code})` : "";
        $35da740d59af89ba$var$yousefGptCountry = countryName ? `${countryName}${countryCode}` : data.country || "";
    } catch (error) {
        $35da740d59af89ba$var$yousefGptCountry = "Unavailable";
    }
};
$35da740d59af89ba$var$loadYousefGptCountry();
const $35da740d59af89ba$var$hasDecorChatUsage = ()=>{
    try {
        return window.sessionStorage?.getItem($35da740d59af89ba$var$decorChatUsageKey);
    } catch (error) {
        return document.documentElement.dataset.decorChatUsed;
    }
};
const $35da740d59af89ba$var$setDecorChatUsage = ()=>{
    document.documentElement.dataset.decorChatUsed = "true";
    try {
        window.sessionStorage?.setItem($35da740d59af89ba$var$decorChatUsageKey, "true");
    } catch (error) {
    // The dataset flag keeps the one-message limit during this page view.
    }
};
const $35da740d59af89ba$var$submitYousefGptMessage = async (message)=>{
    const formData = new URLSearchParams();
    const createdAt = new Date().toISOString();
    const country = $35da740d59af89ba$var$yousefGptCountry || "Pending";
    const deviceType = $35da740d59af89ba$var$detectDeviceType();
    formData.append("form-name", "yousefgpt");
    formData.append("message", message);
    formData.append("page", window.location.href);
    formData.append("language", navigator.language || "");
    formData.append("country", country);
    formData.append("deviceType", deviceType);
    formData.append("userAgent", navigator.userAgent || "");
    formData.append("createdAt", createdAt);
    await fetch("/", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formData.toString()
    });
};
const $35da740d59af89ba$var$appendDecorChatBubble = (container, text, type)=>{
    const bubble = document.createElement("p");
    bubble.className = `decor-chat__bubble decor-chat__bubble--${type}`;
    bubble.textContent = text;
    container.appendChild(bubble);
    container.scrollTop = container.scrollHeight;
};
const $35da740d59af89ba$var$initDecorChat = ()=>{
    const widget = document.querySelector("[data-chat-widget]");
    const toggle = document.querySelector("[data-chat-toggle]");
    const close = document.querySelector("[data-chat-close]");
    const panel = document.querySelector("[data-chat-panel]");
    const form = document.querySelector("[data-chat-form]");
    const input = document.querySelector("[data-chat-input]");
    const messages = document.querySelector("[data-chat-messages]");
    const pageInput = document.querySelector("[data-chat-page]");
    const languageInput = document.querySelector("[data-chat-language]");
    const countryInput = document.querySelector("[data-chat-country]");
    const deviceTypeInput = document.querySelector("[data-chat-device-type]");
    const userAgentInput = document.querySelector("[data-chat-user-agent]");
    const createdAtInput = document.querySelector("[data-chat-created-at]");
    if (!widget || !toggle || !panel || !form || !input || !messages) return;
    const setOpen = (isOpen)=>{
        panel.hidden = !isOpen;
        toggle.setAttribute("aria-expanded", String(isOpen));
        if (isOpen) input.focus();
    };
    toggle.addEventListener("click", ()=>setOpen(panel.hidden));
    close?.addEventListener("click", ()=>setOpen(false));
    form.addEventListener("submit", (event)=>{
        event.preventDefault();
        const message = input.value.trim();
        if (!message) return;
        $35da740d59af89ba$var$appendDecorChatBubble(messages, message, "user");
        if (pageInput) pageInput.value = window.location.href;
        if (languageInput) languageInput.value = navigator.language || "";
        if (countryInput) countryInput.value = $35da740d59af89ba$var$yousefGptCountry || "Pending";
        if (deviceTypeInput) deviceTypeInput.value = $35da740d59af89ba$var$detectDeviceType();
        if (userAgentInput) userAgentInput.value = navigator.userAgent || "";
        if (createdAtInput) createdAtInput.value = new Date().toISOString();
        $35da740d59af89ba$var$submitYousefGptMessage(message).catch(()=>{
        // Netlify Forms receives this on the live site; localhost may reject POST.
        });
        input.value = "";
        if ($35da740d59af89ba$var$hasDecorChatUsage()) {
            $35da740d59af89ba$var$appendDecorChatBubble(messages, "Usage limit has been reached for now. Try again later.", "bot");
            return;
        }
        $35da740d59af89ba$var$setDecorChatUsage();
        const reply = $35da740d59af89ba$var$decorChatReplies[Math.floor(Math.random() * $35da740d59af89ba$var$decorChatReplies.length)];
        $35da740d59af89ba$var$appendDecorChatBubble(messages, reply, "bot");
    });
};
$35da740d59af89ba$var$initDecorChat();
const $35da740d59af89ba$var$initPrivacyModal = ()=>{
    const modal = document.querySelector("[data-privacy-modal]");
    const openButtons = document.querySelectorAll("[data-privacy-open]");
    const closeButtons = document.querySelectorAll("[data-privacy-close]");
    if (!modal || !openButtons.length) return;
    const setOpen = (isOpen)=>{
        modal.hidden = !isOpen;
        document.body.classList.toggle("privacy-modal-open", isOpen);
    };
    openButtons.forEach((button)=>{
        button.addEventListener("click", ()=>setOpen(true));
    });
    closeButtons.forEach((button)=>{
        button.addEventListener("click", ()=>setOpen(false));
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && !modal.hidden) setOpen(false);
    });
};
$35da740d59af89ba$var$initPrivacyModal();


//# sourceMappingURL=repo.f4865f82.js.map
